import React from "react";
import { hexToRgba } from "pages/labelerVideo/utils/hexToRgba";
import {
  PREDICTION_FILL_OPACITY,
  PREDICTION_STRIPE_BACKGROUND_IMAGE,
} from "tools/predictionStripePattern";

const LEGEND_ACCENT = "#5b6bd6";

type LegendItemProps = {
  label: string;
  swatchStyle: React.CSSProperties;
};

const LegendItem = ({ label, swatchStyle }: LegendItemProps) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      fontSize: 12,
      color: "#444",
    }}
  >
    <span
      style={{
        display: "inline-block",
        width: 18,
        height: 12,
        borderRadius: 2,
        ...swatchStyle,
      }}
    />
    {label}
  </span>
);

const predictionSwatchStyle: React.CSSProperties = {
  backgroundColor: hexToRgba(LEGEND_ACCENT, PREDICTION_FILL_OPACITY),
  backgroundImage: PREDICTION_STRIPE_BACKGROUND_IMAGE,
};

type Props = {
  modelLabel?: string | null;
  secondaryModelLabel?: string | null;
};

const IncidentsChartLegend = ({
  modelLabel,
  secondaryModelLabel = null,
}: Props) => (
  <div
    style={{
      display: "flex",
      gap: "16px",
      alignItems: "center",
      flexShrink: 0,
      marginLeft: "auto",
      flexWrap: "wrap",
      justifyContent: "flex-end",
    }}
  >
    <LegendItem
      label="Labeler"
      swatchStyle={{
        backgroundColor: hexToRgba(LEGEND_ACCENT, 0.85),
      }}
    />
    {modelLabel && (
      <LegendItem label={modelLabel} swatchStyle={predictionSwatchStyle} />
    )}
    {secondaryModelLabel && (
      <LegendItem
        label={secondaryModelLabel}
        swatchStyle={predictionSwatchStyle}
      />
    )}
  </div>
);

export default IncidentsChartLegend;
